<template>
  <ProSpaceRightPanel
    :header="header"
    :loading="loading"
    :has-error="hasError"
    class="adjustment-panel"
    @open="open"
    @cancel="cancel"
  >
    <template v-if="isMultipleView()" v-slot:center>
      <ProSpaceVLayout :gap="10">
        <PanelBlockSelectedItems :items="selectedItems" />
        <ProSpacePanelBlock v-if="isAllRowsSelected" class="prospace-panel-block--empty" :header="{title: $t('itemsSelectedAll')}">
          <template #header>
            <ProSpaceAction
              :text="$t('clearTxt')"
              @click="clearPanelAll"
            />
          </template>
        </ProSpacePanelBlock>
        <ProSpacePanelBlock :header="headerAction">
          <ProSpaceVLayout :gap="10">
            <ProSpaceAction
              v-if="showActionAll"
              :text="$t('adjustmentDeclineAll')"
              @click="showConfirmAllMultiselect({
                  confirmTitle: $t('adjustmentDeclineAll'),
                  confirmText: $t('adjustmentAllDeclineAllQuestion'),
                  confirmIcon: 'circle-close',
                  accept: false
                }
              )"
            />
            <ProSpaceAction
              v-if="showActionAll"
              :text="$t('adjustmentAcceptAll')"
              @click="showConfirmAllMultiselect({
                  confirmTitle: $t('adjustmentAcceptAll'),
                  confirmText: $t('adjustmentAllAcceptAllQuestion'),
                  confirmIcon: 'flash-success',
                  accept: true
                }
              )"
            />
            <ProSpaceAction
              :text="$t('adjustmentAddComment')"
              @click="showAdjustmentCommentModal"
            />
            <ProSpaceAction
              v-if="checkAccess('cancel-option')"
              :text="$t('delete')"
              @click="cancel"
            />
          </ProSpaceVLayout>
        </ProSpacePanelBlock>
      </ProSpaceVLayout>
    </template>
    <template v-else-if="selectedCount === 1" v-slot:center>
      <ProSpaceTabs v-model="modelTab" :tabs="tabs">
        <template v-slot:tab-1>
          <ProSpacePanelBlock :header="headerAdjustments" class="adjustment-panel__list">
            <template #header>
              <ProSpaceAction
                v-if="showSaveBtn"
                :disabled="loading || isSaveDisabled"
                :text="$t('save')"
                @click="save"
              />
              <ProSpaceDots
                v-if="showDotsInPanel"
                :options="dotsOptions"
                @action="(action) => handleDots(action)"
              />
            </template>
            <ProSpaceVLayout :gap="5">
              <AdjustmentBlock
                v-for="(editedField, index) in editedFields"
                :key="index"
                :editedField="editedField"
                :disabled="isProceeded"
                :checkAccess="checkAccess"
                :currentStatus="currentStatus"
                :adjustmentStatus="adjustment?.status"
              />
            </ProSpaceVLayout>
          </ProSpacePanelBlock>
        </template>
        <template v-slot:tab-2>
          <ProSpaceTimeLineCondition
            :dateFormat="userinfo.dateFormat"
            :timeFormat="userinfo.timeFormat"
            :dateTimeFormatter="getFormatDateTime"
            :elems="adjustmentComments"
            :commentTile="$t('adjustmentComment')"
            :title="$t('adjustmentComments')"
            :titleAction="$t('adjustmentAddComment')"
            :showMarker="false"
            @add="showAdjustmentCommentModal"
          >
            <template v-if="!adjustmentComments.length" v-slot:empty>
              <ProSpaceEmptyGrid
                :title="$t('adjustmentEmptyCommentsTitleTxt')"
                :text="$t('adjustmentEmptyCommentsTextTxt')"
                icon="empty-grid"
              />
            </template>
          </ProSpaceTimeLineCondition>
        </template>
        <template #tab-3>
          <ProSpacePanelBlock :header="headerHistory">
          </ProSpacePanelBlock>
          <ProSpaceVLayout :gap="10" is-inline-h v-if="adjustment">

            <ProSpaceVLayout :gap="5" class="padding-10 ui-shadow" v-if="adjustment.createdAt">
              <ProSpaceHLayout justify-content="space-between">
                <span class="text-icon-gray text-size-11">{{ getFormatDateTime(adjustment.createdAt) }}</span>
                <ProSpaceTag :text="$t(adjustment.creatorRole || '')" type="gray-light" bordered />
              </ProSpaceHLayout>
              <ProSpaceHLayout class="padding-top-5">
                <span class="text-size-12 text-bold text-color-main">{{ adjustment.creatorDisplayName }}</span>
              </ProSpaceHLayout>
              <ProSpaceHLayout>
                <span class="text-size-12 text-color-accent">{{ $t('created') }}</span>
              </ProSpaceHLayout>
            </ProSpaceVLayout>

            <ProSpaceVLayout :gap="5" class="padding-10 ui-shadow" v-if="adjustment.acceptedAt">
              <ProSpaceHLayout justify-content="space-between">
                <span class="text-icon-gray text-size-11">{{ getFormatDateTime(adjustment.acceptedAt) }}</span>
                <ProSpaceTag :text="$t(adjustment.acceptorRole || '')" type="gray-light" bordered />
              </ProSpaceHLayout>
              <ProSpaceHLayout class="padding-top-5">
                <span class="text-size-12 text-bold text-color-main">{{ adjustment.acceptorDisplayName }}</span>
              </ProSpaceHLayout>
              <ProSpaceHLayout>
                <span class="text-size-12 text-color-accent">{{ $t('agreed') }}</span>
              </ProSpaceHLayout>
            </ProSpaceVLayout>

            <ProSpaceVLayout :gap="5" class="padding-10 ui-shadow" v-if="adjustment.approvedAt">
              <ProSpaceHLayout justify-content="space-between">
                <span class="text-icon-gray text-size-11">{{ getFormatDateTime(adjustment.approvedAt) }}</span>
                <ProSpaceTag :text="$t(adjustment.approverRole || '')" type="gray-light" bordered />
              </ProSpaceHLayout>
              <ProSpaceHLayout class="padding-top-5">
                <span class="text-size-12 text-bold text-color-main">{{ adjustment.approverDisplayName }}</span>
              </ProSpaceHLayout>
              <ProSpaceHLayout>
                <span class="text-size-12 text-color-accent">{{ $t('approved') }}</span>
              </ProSpaceHLayout>
            </ProSpaceVLayout>

          </ProSpaceVLayout>
        </template>
      </ProSpaceTabs>
    </template>
    <template v-if="selectedCount === 1 && checkAccess('metainfo-block')" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
  <ProSpaceModal
    v-model="adjustmentCommentModalShow"
    icon="plus"
    :key="`adjustment-сomment-${adjustmentCommentModalShow}`"
    :title="$t('adjustmentComment')"
    :width="405"
    :cancelTxt="$t('cancelTxt')"
    :applyTxt="$t('adjustmentCommentSend')"
    :validate-local="$t"
    :validate-model="adjustmentCommentModel"
    :validate-config="{
      comment: {
        required
      }
    }"
    @apply="addComment"
  >
    <template #default="{ v }">
      <ProSpaceVLayout :gap="0">
        <ProSpaceInputText
          :label="$t('adjustmentComment')"
          v-model="adjustmentCommentModel.comment"
          :placeholder="$t('adjustmentComment')"
          :invalid="v.comment.$error"
          :invalid-messages="v.comment.$errors"
          isTextarea
          :rows="3"
          @blur="v.comment.$touch"
        />
      </ProSpaceVLayout>
    </template>
  </ProSpaceModal>
  <ProSpaceFlashMessage
    v-if="showConfirmModel"
    v-model="showConfirmModel"
    :type="confirmType"
    :icon="confirmIcon"
    :title="confirmTitle"
    :applyTxt="confirmApplyTxt"
    :cancelTxt="confirmCancelTxt"
    @apply="applyConfirm"
  >
    {{ confirmText }}
  </ProSpaceFlashMessage>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
  ProSpaceTimeLineCondition,
  ProSpaceInputText,
  ProSpaceModal,
  ProSpaceVLayout,
  ProSpaceDots,
  ProSpaceFlashMessage,
  ProSpaceEmptyGrid,
  ProSpaceSimpleGrid,
  ProSpaceHLayout,
  ProSpaceTag
} from "@prospace/prospace-components-library";
import AdjustmentBlock from "./AdjustmentBlock";
import AdjustmentOutletsGrid from "./AdjustmentOutletsGrid.vue";
import { AdjustmentService } from "../../../services/AdjustmentService";
import { AdjustmentCommentService } from "../../../services/AdjustmentCommentService";
import { mapGetters } from "vuex";
import { getAMorPM } from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
const _ = require("lodash");
import {
  useMultiSelectRightPanel,
} from "@composes/multiselect"
import PanelBlockSelectedItems from "@multiselect/PanelBlockSelectedItems"
export default {
  name: "AdjustmentPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
    ProSpaceTimeLineCondition,
    ProSpaceInputText,
    ProSpaceDots,
    ProSpaceModal,
    ProSpaceVLayout,
    ProSpaceFlashMessage,
    AdjustmentBlock,
    AdjustmentOutletsGrid,
    ProSpaceEmptyGrid,
    ProSpaceSimpleGrid,
    ProSpaceHLayout,
    ProSpaceTag,
    PanelBlockSelectedItems
  },
  props: {
    periodId: {
      type: Number,
      required: true,
    },
    getDots: {
      type: Function
    },
    checkAccess: {
      type: Function
    },
    wrapperCheckRoles: {
      type: Function
    },
    modelFastFilter: {
      type: Object,
      default: () => {}
    },
    selectedStatuses: {
      type: Array,
      default: () => []
    },
    isAllRowsSelected: {
      type: Boolean,
      default: false
    },
    adjustmentFilter: {
      type: String
    },
    selectedModel: {
      type: Array
    }
  },
  setup() {
    const { selectedData, selectedClude, selectedCount, isMultipleView } = useMultiSelectRightPanel()
    return {
      selectedData, selectedClude, selectedCount, isMultipleView
    }
  },
  data() {
    return {
      currentStatus: '',
      adjustment: null,
      adjustmentModels: null,
      adjustmentComments: [],
      addressPrograms: [],
      addressProgramsPerPage: 5,

      adjustmentService: new AdjustmentService(),
      adjustmentCommentService: new AdjustmentCommentService(),

      loading: false,
      hasError: false,
      adjustmentCommentModalShow: false,
      showAddressProgramsModel: false,
      modelModalClude: false,

      showConfirmModel: false,
      confirmIcon: "",
      confirmType: "",
      confirmTitle: "",
      confirmText: "",
      confirmApplyTxt: "",
      confirmCancelTxt: "",
      applyConfirm: () => {},

      modelTab: { name: this.$t("adjustments"), isActive: true, systemName: "adjustments" },
      editedFields: [],
      adjustmentCommentModel: {
        comment: "",
        role: null,
        adjustmentId: null
      },
      canDeclineInComment: false,
      isLoadedComments: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
      currentPeriod: "marsPeriodStore/getMarsPeriod",
    }),
    showDotsInPanel() {
      if (this.adjustment?.status === 'completed') return false
      if (this.adjustment?.status === 'onacceptance' && this.checkAccess('adjustments-acceptance')) return true
      else if (this.adjustment?.status === 'onapproval' && this.checkAccess('adjustments-approval')) return true
    },
    showSaveBtn() {
      if (this.adjustment?.status === 'completed') return false
      if (this.adjustment?.status === 'onacceptance' && this.checkAccess('adjustments-acceptance')) return true
      else if (this.adjustment?.status === 'onapproval' && this.checkAccess('adjustments-approval')) return true
    },
    showActionAll() {
      const isAcceptance = this.checkAccess('adjustments-acceptance')
      const isApproval = this.checkAccess('adjustments-approval')

      return isApproval || isAcceptance
    },
    isSaveDisabled() {
      return this.selectedStatuses[0] === 'completed' || this.editedFields.some(obj => obj[this.currentStatus] === null)
    },
    isResetDisabled() {
      return this.selectedStatuses[0] === 'completed' || this.editedFields.every(obj => obj[this.currentStatus] === null)
    },
    headerClude() {
      return {
        title: this.$t(`${this.selectedClude.isAll ? 'itemsExcluded' : 'itemsIncluded'}`),
        counter: this.selectedClude.items.length,
        showCounter: true,
      }
    },
    headerAdjustments() {
      return {
        title: this.$t("adjustments"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("adjustmentMetaBlock"),
        isExpand: true,
      };
    },
    headerHistory() {
      return {
        title: this.$t('history'),
        isExpand: false
      }
    },
    tabs() {
      return [
        {
          name: this.$t("adjustments"),
          systemName: "adjustments",
          isActive: this.modelTab.systemName === "adjustments"
        },
        {
          name: this.$t("adjustmentComments") ,
          systemName: "adjustmentComments",
          isActive: this.modelTab.systemName === "adjustmentComments"
        },
        {
          name: this.$t("history") ,
          systemName: "history",
          isActive: this.modelTab.systemName === "history"
        },
      ];
    },
    header() {
      if (this.adjustment) {
        return {
          title: this.adjustment.agencyValue,
          id: this.adjustment.code,
          status: this.getStatus(this.adjustment.status),
          options: this.getDots(this.adjustment),
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelectAll"),
        counter: this.getCounter,
        showCounter: true,
      };
    },
    headerAction() {
      return {
        title: this.$t("actions"),
      };
    },
    contentBottom() {
      if (this.adjustment) {
        return [
        [
            {
              title: this.$t("createdByTxt"),
              text: this.adjustment.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.adjustment.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text: this.getFormatDateTime(this.adjustment.createdAt) + ' ' + getAMorPM(this.adjustment.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text: this.getFormatDateTime(this.adjustment.lastUpdated) + ' ' + getAMorPM(this.adjustment.createdAt, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
    dotsOptions() {
      let res = [
        {
          name: "acceptAll",
          text: this.$t("adjustmentAcceptAll"),
          icon: "circle-check",
          method: this.showConfirmAcceptAll,
          liteRef: "adjustment-proceed",
          itemClassName: "prospace-dots-item--h34 adjustment-item__dots_itemMenu",
          iconSize: "15px",
          iconGap: 5,
        },
        {
          name: "declineAll",
          text: this.$t("adjustmentDeclineAll"),
          icon: "ban",
          method: this.showConfirmDeclineAll,
          liteRef: "adjustment-proceed",
          itemClassName: "prospace-dots-item--h34",
          iconSize: "20px",
          iconGap: 5,
        },
        {
          name: "resetAll",
          text: this.$t("adjustmentResetAll"),
          icon: "rotate-left-file",
          method: this.resetStatus,
          liteRef: "adjustment-proceed",
          last: true,
          disabled: this.isResetDisabled,
          itemClassName: "prospace-dots-item--h34 adjustment-item__dots_itemMenu",
          iconSize: "14px",
          iconGap: 5,
        },
      ];
      return res;
    },
    isProceeded() {
      return this.adjustment && this.adjustment.status === "adjustmentComplete";
    },
    isUnsavedChanges() {
      if(!this.ids || this.count > 1)
        return false;

      let prevValues = this.adjustment ? JSON.parse(this.adjustment.editedFieldsConfig) : null;

      if(!prevValues)
        return false;

      return this.editedFields.some(x => prevValues.find(f => f.key === x.key).status !== x.status);
    },
    checkFastFilter() {
      return this.modelFastFilter?.value
        .find(
          f =>
            f.field === "status" &&
            f.value === "adjustmentComplete"
        );
    },
    checkSelectedStatuses() {
      if (this.selectedStatuses?.length > 0) {
        return this.selectedStatuses?.some(s => s !== "adjustmentComplete");
      }
    },
    selectedItems() {
      return [
        {
          name: this.$t('code'),
          value: 'code', f: (v) => v
        },
        {
          name: this.$t('adjustmentEditedFields'),
          value: 'editedFields'
        }
      ]
    },
    getCounter() {
      return this.selectedCount || 0;
    }
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
    selectedData() {
      this.update();
      this.isLoadedComments = false;
      if (!this.isLoadedComments && this.modelTab.systemName === 'adjustmentComments') {
        this.refreshComments();
      }
    },
    selectedCount() {
      this.update();
    },
    modelTab(tab) {
      if (tab.systemName === "adjustmentComments" && !this.isLoadedComments) {
        this.refreshComments();
      }
    }
  },
  methods: {
    checkEveryStatus(status) {
      if (this.selectedStatuses?.length > 0) {
        return this.selectedStatuses?.every(s => s === status);
      }
    },
    update() {
      this.hasError = false;
      try {
        this.getAdjustment();
      } catch (e) {
        this.hasError = true;
      }
    },
    getAdjustment() {
      if (this.selectedCount === 1) {
        this.loading = true;
        this.adjustmentService.get(this.selectedData.id, this.periodId).then((res) => {
          this.adjustment = res.data;
          this.editedFields = JSON.parse(res.data.editedFieldsConfig);
          if (this.adjustment?.status === 'onacceptance') {
            this.currentStatus = 'acceptanceStatus'
          } else if (this.adjustment?.status === 'onapproval') {
            this.currentStatus = 'approvalStatus'
          }
          // this.getAddressPrograms();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
      } else if (this.selectedCount > 1){
        this.loading = true;
        this.adjustmentService.getMany(this.ids, this.periodId).then((res) => {
          this.adjustmentModels = res.data.records;
          this.adjustmentModels = this.adjustmentModels?.filter(m => m.status !== "adjustmentComplete");
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
      }
      this.adjustmentModels = null;
      this.adjustment = null;
    },
    handleDots(action) {
      var option = this.dotsOptions.find((o) => o.name === action);
      option.method();
    },
    getStatus(status) {
      if (!status) return;

      let type = "default"
      switch (status) {
        case "onacceptance":
          type = "light-blue"
          break;
        case "onapproval":
          type = "blue"
          break;
        case "completed":
          type = "teal"
          break;
        case "deleted":
          type = "draft"
          break;
      }

      return {
        type: type,
        text: status !== 'deleted' ? this.$t(status) : this.$t('adjustmentDeleted'),
      };
    },
    clearPanel() {
      if (!this.isAllRowsSelected && (this.count === this.selectedClude.items?.length)) {
        this.$emit("clear");
      } else if (this.isAllRowsSelected && (this.count > this.selectedClude.items?.length) && this.selectedClude.isAll) {
        this.$emit("clear:excluded");
      } else {
        this.$emit("clear");
      }
    },
    clearPanelAll() {
      this.$emit("clear");
    },
    open() {
      this.$emit("open", this.adjustment);
    },
    refresh() {
      this.$emit("refresh");
    },
    refreshComments() {
      this.loading = true;
      this.adjustmentCommentService.getByAdjustmentId(this.selectedData.id, this.periodId).then((res) => {
        this.adjustmentComments = res.data.records.map(x => {
          const role = this.$t((x.role)) || '';
          return {
            securityUserType: role,
            confirmDate: x.createdAt,
            securityUserFirstName: x.fio.split(' ')[0],
            securityUserLastName: x.fio.split(' ')[1],
            comment: x.comment
          }
        });
        this.loading = false;
        this.isLoadedComments = true;
      })
      .catch(() => {
        this.loading = false;
      });
    },
    showConfirmAcceptAll() {
      this.confirmType = "default";
      this.confirmIcon = "flash-success";
      this.confirmTitle = this.$t("adjustmentAcceptAll");
      this.confirmText = this.$t("adjustmentParametersAcceptAllQuestion");
      this.confirmApplyTxt = this.$t("confirmTxt");
      this.confirmCancelTxt = this.$t("cancelTxt");
      this.applyConfirm = () => { this.acceptAll() };
      this.showConfirmModel = true;
    },
    showConfirmDeclineAll() {
      this.confirmType = "default";
      this.confirmIcon = "circle-close";
      this.confirmTitle = this.$t("adjustmentDeclineAll");
      this.confirmText = this.$t("adjustmentParametersDeclineAllQuestion");
      this.confirmApplyTxt = this.$t("confirmTxt");
      this.confirmCancelTxt = this.$t("cancelTxt");
      this.applyConfirm = () => { this.declineAll() };
      this.showConfirmModel = true;
    },
    showConfirmAllMultiselect(config) {
      const {confirmTitle, confirmText, confirmIcon, accept} = config;
      this.confirmType = "default";
      this.confirmIcon = confirmIcon;
      this.confirmTitle = confirmTitle;
      this.confirmText = confirmText;
      this.confirmApplyTxt = this.$t("confirmTxt");
      this.confirmCancelTxt = this.$t("cancelTxt");
      this.applyConfirm = () => { this.acceptAllMultiselect(accept) };
      this.showConfirmModel = true;
    },
    showAddressPrograms() {
      this.showAddressProgramsModel = true;
    },
    cancel() {
      this.$emit("cancel", this.selectedModel.length > 0 ? this.selectedModel : this.selectedData);
    },
    acceptAll() {
      this.loading = true
      this.editedFields.forEach(f => {
        f[this.currentStatus] = true;
      });
      this.adjustment.editedFieldsConfig = JSON.stringify(this.editedFields);
      this.saveAdjustments(this.adjustment);
    },
    declineAll() {
      this.loading = true
      this.editedFields.forEach(f => {
        f[this.currentStatus] = false;
      });
      this.adjustment.editedFieldsConfig = JSON.stringify(this.editedFields);
      this.saveAdjustments(this.adjustment);
    },
    checkStatus() {
        if (this.checkAccess('adjustments-acceptance')) {
          return 'acceptanceStatus';
        } else if (this.checkAccess('adjustments-approval')) {
          return 'approvalStatus';
        }
    },
    getRequestParams() {
      let records = []
      let filter = ""

      if (this.selectedClude?.isAll) {
        records = this.selectedClude.items
        filter = this.getFilterString()
      } else if (this.selectedClude?.items.length > 0) {
        records = this.selectedClude.items
      }

      return {
        records, filter
      }
    },
    acceptAllMultiselect(accept = true) {
      this.loading = true;
      let params = {};
      const isAll = this.selectedClude?.isAll;
      const isMultiple = this.selectedClude?.items.length > 1;
      const requestParams = this.getRequestParams();
      const records = requestParams.records;
      const filter = requestParams.filter;
      const status = this.checkStatus(records);

      records.length > 0 ? records.forEach(x => {
        let efConfig = JSON.parse(x.editedFieldsConfig);
        efConfig.forEach(f => {
          f[status] = accept;
        });
        x.editedFieldsConfig = JSON.stringify(efConfig);
      }) : '';
      params = {
        data: records,
        filter: filter,
        accept: accept
      }
      this.saveAdjustments(params, isMultiple, isAll, status);
    },
    resetAll() {
      this.editedFields = JSON.parse(this.adjustment.editedFieldsConfig);
    },
    resetStatus() {
      this.editedFields.forEach(s => s[this.currentStatus] = null);
    },
    save() {
      this.loading = true
      this.adjustment.editedFieldsConfig = JSON.stringify(this.editedFields.map((item) => {
        item[this.currentStatus] = item[this.currentStatus] === 'true' || item[this.currentStatus] === true
        return item
      }));
      this.saveAdjustments(this.adjustment, false);
    },
    saveAdjustments(params, isMultipleAdjustments, isAll, status) {
      this.loading = true
      let method
      if (isMultipleAdjustments || isAll) {
        method = status === 'acceptanceStatus' ? 'acceptAdjustments' : 'approveAdjustments'
        if (this.checkAccess('adjustments-acceptance')) {
          method = 'acceptAdjustments';
        } else {
          method = 'approveAdjustments';
        }
      } else if (!isMultipleAdjustments) {
        method = this.currentStatus === 'approvalStatus' ? 'approveAdjustment' : 'acceptAdjustment'
      }
      this.adjustmentService[method](params).then(() => {
        this.refresh();
        this.loading = false;
        this.clearPanel()
      });
    },
    addComment() {
      this.loading = true
      let commentsToAdd
      if (this.selectedModel.length) {
        commentsToAdd = this.selectedModel.map(data => Object.assign(_.cloneDeep(this.adjustmentCommentModel), { adjustmentId: data.id }));
      } else {
        commentsToAdd = [this.selectedData].map(data => Object.assign(_.cloneDeep(this.adjustmentCommentModel), { adjustmentId: data.id }));
      }
      let declineMethod = commentsToAdd.length > 1 ? this.acceptAllMultiselect : this.declineAll;

      this.adjustmentCommentService.createMany(commentsToAdd, this.currentPeriod.id).then(() => {
        if (this.canDeclineInComment) {
          declineMethod(false);
          this.canDeclineInComment = false;
        } else {
          this.refreshComments();
        }
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
    },
    showAdjustmentCommentModal() {
      this.adjustmentCommentModel.comment = "";
      this.adjustmentCommentModel.role = JSON.parse(localStorage.getItem("userRole")).systemName;
      this.adjustmentCommentModalShow = true;
    },
    getFilterString() {
      return this.adjustmentFilter.split("&$top")[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.adjustment-panel {
  :deep(.prospace-panel-header__title .prospace-tag) {
    text-transform: uppercase;
  }
  &__list {
    :deep(.prospace-panel-block__body) {
      padding: 0;
    }
  }
  :deep(.prospace-panel-block-item__content_text) {
    font-size: 12px;
  }
  :deep(.prospace-timeline-condition .time-line-header .prospace-action-text) {
    font-size: 12px;
  }
  :deep(.prospace-timeline-condition .time-line-element .prospace-tag__text) {
    font-weight: 400;
  }
  :deep(.prospace-timeline-condition .time-line-element .time-line-element__comment-title) {
    color: var(--prospace-tag-draft);
  }
  :deep(.prospace-panel-header__subline .prospace-tag) {
    font-size: 11px;
  }
  :deep(.prospace-panel-header__subline .prospace-tag--gray-light) {
    font-weight: 400;
  }
  :deep(.prospace-panel-block--empty .prospace-panel-block-header) {
    margin-bottom: 0;
  }
}
.prospace-timeline-condition {
  width: 100%;
}
</style>
